import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import StyledLink from "../StyledLink";

const LabelLink = ({ labelText, linkText, handleClick, alignment = "row" }) => {
  return (
    <LabelLinkWrapper alignment={alignment}>
      <TextFont fontWeight="400" fontSize="1rem" fontColor={Colors.white}>
        {labelText}
      </TextFont>
      <StyledLink
        linkText={linkText}
        handleClick={handleClick}
        linkTextColor={Colors.pomegranate}
        linkTextWeight="400"
        underlineRequired
      />
    </LabelLinkWrapper>
  );
};

export default LabelLink;

const LabelLinkWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => props.alignment};
  gap: 0.375rem;
  justify-content: center;
  align-items: center;
`;
